import { toastError, toastSuccess, toastWarn } from "../../../components/Toast";
import useAuthData from "../../../hook/useAppData";
import { filterIsChecked, isTimeApproved } from "../lib";
import { postNotifyType, notifyCollaborator, notifyProjectManager, timeWorkNotifyLeadApprove, timeWorkNotifyTimeWorked } from "../service";
import useApprovalHours from "../store/useApprovalHours";
//@ts-ignore
import { CSVLink } from "react-csv";
import { ModalPopUp } from "../../../components/ModalPopUp";
import { useEffect, useState } from "react";
import { IconFilter } from "../../../icons";
import { ACCESS } from "../../Profile/constants";
import InputSelect from "../../../components/Input-select";
import Button from "../../../components/Button";
import { getProfiles } from "../../Profile/service";
import { getJobRoles } from "../../JobsRoles/service";
import "./index.scss";
import { getRoleInProject } from "../../RoleInProject/service";

export function ButtonGroupApproved() {
  const { token, accessIds } = useAuthData();
  const { listRender, getComponet, modalStatus, setModalStatus, monthAndYear, handleSaveApi, csv, csvStatus, optionListSelected, setModalFilters } =
    useApprovalHours();
  const [needModalNotificateStatus, setNeedModalNotificateStatus] = useState(false);
  const [notifyProfile, setNotifyProfile] = useState({
    role: [],
    profile: [],
  });
  const [notifyType, setNotifyType] = useState<number>(0);
  const [valueProfile, setValueProfile] = useState(0);

  const notifyTypeDTO = {
    // 1: "excess",
    1: "missing",
    2: "notify",
  };

  async function handleNotifyType() {
    const body = { profileId: +valueProfile, notificade: notifyTypeDTO[notifyType] };
    const response = await postNotifyType(body, token);
    if (response?.ok) toastSuccess("Notificação enviada com sucesso!");
    else notifyTypeDTO[notifyType] === "excess" ? toastError("Não há horas em excesso!") : toastError("Notificação não enviada!");
  }

  async function handleToSendEmail() {
    const formData = filterIsChecked(listRender);
    if (!formData?.length) return toastWarn("Selecione um profissional!");
    const data = {
      timesWorkIds: returnListIdUser(formData),
    };
    const response = await timeWorkNotifyTimeWorked(token, data);
    try {
      if (!response?.ok) return toastError("Ops! Tente novamente");
      toastSuccess("E-mails enviado com sucesso!");
      getComponet();
    } catch {
      console.error(response);
    }
  }

  function handleSubmitChecked() {
    const formData = filterIsChecked(listRender);
    if (!formData?.length) return toastWarn("Selecione um profissional!");
    const isApproved = isTimeApproved(formData);

    if (!isApproved) {
      const data = formData?.map((item) => {
        const obj = {
          timeWorkId: item.id,
          timeApproved: item.timeApproved === "" ? null : item.timeApproved || item.timeWorked,
        };
        return obj;
      });
      handleSaveApi(data);
    } else {
      setModalStatus(!modalStatus);
    }
  }

  function returnListIdUser(data: any[]) {
    return data?.map((item) => item.id);
  }

  function ButtonNotificate() {
    useEffect(() => {
      catchList();
    }, []);

    async function catchList() {
      const profile = await getProfiles(token);
      const role = await getRoleInProject({ token });
      setNotifyProfile({ profile: profile, role: role });
    }

    function switchList() {
      return notifyTypeDTO[notifyType] === "missing" ? notifyProfile.profile : notifyProfile.role;
    }

    return (
      <div className="w-full h-3/5 flex-wrap flex flex-col">
        <div className="flex flex-row my-4 p-6">
          <div className="flex w-full">
            <InputSelect
              name="whatNotify"
              label={"O que deseja notificar?"}
              list={[
                // { value: 1, label: "Excesso de Horas" },
                { value: 1, label: "Horas abaixo" },
                { value: 2, label: "Aprovar Horas" },
              ]}
              value={notifyType}
              onChange={(e) => setNotifyType(e.target.value)}
            />
          </div>
          <div className="flex w-full">
            <InputSelect
              name="whoNotify"
              label={"Quem deseja notificar?"}
              list={switchList()}
              value={valueProfile}
              onChange={(e) => setValueProfile(e.target.value)}
            />
          </div>
        </div>
        <div className="flex flex-row justify-end gap-2 mt-5 pr-10">
          <Button className="bg-secondary" onClick={() => setNeedModalNotificateStatus((oldStatus: boolean) => !oldStatus)}>
            Cancelar
          </Button>
          <Button className="bg-primary" onClick={handleNotifyType}>
            Notificar
          </Button>
        </div>
      </div>
    );
  }

  function verefyPointClass() {
    if (optionListSelected === 1) return "box-shadow exceeded";
    if (optionListSelected === 2) return "box-shadow below";
    if (optionListSelected === 3) return "box-shadow normal";
  }

  function verefyPointClassBox() {
    if (optionListSelected === 1) return "box-point-status-filter-exceeded";
    if (optionListSelected === 2) return "box-point-status-filter-below";
    if (optionListSelected === 3) return "box-point-status-filter-normal";
  }

  return (
    <>
      <ModalPopUp
        className="modal-notify w-2/5 min-h-60vh"
        title="Notificações de Rotina"
        status={needModalNotificateStatus}
        onClickCancel={() => setNeedModalNotificateStatus((oldStatus: boolean) => !oldStatus)}
        children={ButtonNotificate()}
      />
      <div className="titleContainer box-title">
        <h1 className="font-poppins flex">
          Aprovação de Horas{" "}
          <div className={`box-point-status-filter ${verefyPointClassBox()}`}>
            <span className={`point-status-filter ${verefyPointClass()}`}></span>
          </div>{" "}
        </h1>

        <div className={`rowBtnContainer`}>
          <div>
            <button onClick={() => setModalFilters(true)} className="btn bg-secondary gap">
              <span className="icon-filter-routine-appoiment flex center">{IconFilter}</span> Filtros
            </button>
            <button className="btn Link" onClick={handleSubmitChecked}>
              Aprovar horas
            </button>

            {accessIds?.includes(ACCESS.APPROVAL_HOURS_notification) && (
              <>
                <button className="Link email btn" onClick={() => setNeedModalNotificateStatus((oldStatus: boolean) => !oldStatus)}>
                  Notificação de rotina
                </button>
              </>
            )}
            {accessIds?.includes(ACCESS.APPROVAL_HOURS_download) && (
              <>
                {csvStatus ? (
                  <CSVLink data={csv} filename={`${monthAndYear}.csv`} target="_blank" className="csvLink">
                    <button className="Link email btn">Download CSV</button>
                  </CSVLink>
                ) : (
                  <button className="Link email btn" disabled>
                    Download CSV
                  </button>
                )}
              </>
            )}
          </div>
          <div>
            {accessIds?.includes(ACCESS.APPROVAL_HOURS_invoice) && (
              <>
                <button className="Link btn" onClick={handleToSendEmail}>
                  Emitir nota fiscal
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
